<template>
  <div class="">
    <!-- test -->
    <FuseSelect
      style="width: 200px"
      :options="unitSelection"
      :value="value"
      @input="$emit('input', $event)"
    >
      <template #scroll>
        <div
          class="absolute left-0 top-0 bg-white shadow p-2"
          style="transform: translateX(-40px); width: 40px; height: 100%"
        >
          left
        </div>
        <div>test</div>
      </template>
    </FuseSelect>
  </div>
</template>

<script setup>
import { ref, onUnmounted } from 'vue';

import FuseSelect from '@/components/custom-ui/FuseSelect.vue';
import { useElementSize, useStyleTag } from '@vueuse/core';
import { customCss } from '../table-view/quasar.js';

const { id, css, load, unload } = useStyleTag(customCss, { id: 'naruto' });
onUnmounted(() => {
  unload();
});

defineProps({ value: {} });

const unitSelection = JSON.parse(localStorage.getItem('unitSelection'));
</script>

<style scoped></style>
